import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
//import { ChartsModule } from 'ng2-charts';
import { NgxEchartsModule } from 'ngx-echarts';

import { CustomMaterialModule } from '../custom-material/custom-material.module';
import { MainModule } from '../main/main.module';

import { StatsComponent } from './stats/stats.component';
import { LinechartComponent } from './linechart/linechart.component';
import { TranslocoRootModule } from '../transloco/transloco-root.module';

@NgModule({
  declarations: [StatsComponent, LinechartComponent],
  exports: [StatsComponent, LinechartComponent],
  imports: [
    CommonModule, FormsModule,
    CustomMaterialModule, MainModule,
    TranslocoRootModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
  ]
})
export class StatisticsModule { }